// src/components/ContactMap.jsx - COMPLETELY REDESIGNED
import React from 'react';

var isGJ = false;

const ContactMap = () => {
  const domain = window.location.hostname;
  
  if (domain.includes("gojuris.ai")) {
    isGJ = true;
  }

  const quickLinks = [
    { icon: 'bx-calendar-check', text: 'Book a Demo/Appointment' },
    { icon: 'bx-phone-call', text: 'Request a call back' },
    { icon: 'bx-download', text: 'Download Brochure' },
    { icon: 'bx-video', text: 'Tutorials/Videos' },
    { icon: 'bx-gift', text: 'Special Offers/Plans' },
    { icon: 'bx-message-dots', text: 'Live Chat' }
  ];

  return (
    <section className="modern-contact-section">
      <div className="container">
        <div className="row g-5 align-items-center">
          {/* Left - Map */}
          <div className="col-lg-6">
            <div className="map-container">
              <div className="map-overlay">
                <div className="location-badge">
                  <i className="bx bx-map-pin"></i>
                  <div className="location-text">
                    <strong>LEGAL LAW PUBLICATIONS</strong>
                    <span>Aurangabad (INDIA)</span>
                  </div>
                </div>

                <div className="map-placeholder">
                  <div className="map-icon">
                    <i className="bx bx-map"></i>
                  </div>
                  
                  {/* Location Markers */}
                  <div className="location-marker marker-1">
                    <div className="marker-pulse"></div>
                    <i className="bx bx-current-location"></i>
                  </div>

                  <div className="location-marker marker-2">
                    <i className="bx bx-building"></i>
                  </div>

                  <div className="location-marker marker-3">
                    <i className="bx bx-building-house"></i>
                  </div>
                </div>

                {/* <div className="location-tags">
                  <div className="tag">🇮🇳 India</div>
                  <div className="tag">🇦🇪 Dubai</div>
                  <div className="tag">🇸🇬 Singapore</div>
                </div> */}
              </div>
            </div>
          </div>

          {/* Right - Contact Info */}
          <div className="col-lg-6">
            <div className="contact-content">
              <div className="contact-badge">
                <i className="bx bx-phone-call"></i>
                <span>Get in Touch</span>
              </div>

              <h2 className="contact-title">
                Try <span className="gradient-text">{isGJ ? 'LJSoft Online' : 'LJSoft Online '}</span>
              </h2>

              <p className="contact-description">
                Experience the future of legal research. Book a demo, download our brochure, 
                or connect with our team to get started.
              </p>

              {/* Quick Links Grid */}
              <div className="quick-links-grid">
                {quickLinks.map((link, index) => (
                  <div key={index} className="quick-link-card">
                    <i className={`bx ${link.icon}`}></i>
                    <span>{link.text}</span>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="contact-actions">
                <button className="contact-btn primary-contact-btn">
                  <i className="bx bx-calendar-plus"></i>
                  <span>Book Demo</span>
                </button>

                <button className="contact-btn secondary-contact-btn">
                  <i className="bx bx-phone-call"></i>
                  <span>Call Now</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        /* ============================================
           MODERN CONTACT SECTION
        ============================================ */
        .modern-contact-section {
          padding: 80px 0;
          background: #ffffff;
        }

        /* Map Container */
        .map-container {
          position: relative;
          height: 600px;
          background: linear-gradient(135deg, #E91E63 0%, #c41849 100%);
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        .map-overlay {
          position: relative;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          padding: 32px;
        }

        /* Location Badge */
        .location-badge {
          display: inline-flex;
          align-items: center;
          gap: 12px;
          padding: 16px 24px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
          margin-bottom: auto;
          align-self: flex-start;
        }

        .location-badge i {
          font-size: 28px;
          color: #c41849;
        }

        .location-text {
          display: flex;
          flex-direction: column;
        }

        .location-text strong {
          font-size: 16px;
          font-weight: 700;
          color: #1a1a1a;
        }

        .location-text span {
          font-size: 14px;
          color: #666;
        }

        /* Map Placeholder */
        .map-placeholder {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          height: 60%;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .map-icon {
          font-size: 100px;
          color: rgba(255, 255, 255, 0.2);
        }

        /* Location Markers */
        .location-marker {
          position: absolute;
          width: 48px;
          height: 48px;
          background: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
          animation: markerBounce 2s ease-in-out infinite;
        }

        @keyframes markerBounce {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .location-marker i {
          font-size: 24px;
          color: #c41849;
        }

        .marker-1 {
          top: 30%;
          left: 40%;
          animation-delay: 0s;
        }

        .marker-2 {
          top: 60%;
          right: 25%;
          animation-delay: 0.5s;
        }

        .marker-3 {
          bottom: 25%;
          left: 30%;
          animation-delay: 1s;
        }

        .marker-pulse {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          background: rgba(233, 30, 99, 0.3);
          animation: pulse 2s ease-out infinite;
        }

        @keyframes pulse {
          0% {
            transform: scale(1);
            opacity: 1;
          }
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }

        /* Location Tags */
        .location-tags {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          align-self: flex-start;
        }

        .tag {
          padding: 10px 20px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          border-radius: 50px;
          font-size: 14px;
          font-weight: 600;
          color: #333;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        }

        /* Contact Content */
        .contact-content {
          animation: slideInRight 0.8s ease 0.3s both;
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(30px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .contact-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 8px 20px;
          background: linear-gradient(135deg, rgba(245, 166, 35, 0.1), rgba(233, 30, 99, 0.1));
          border-radius: 50px;
          margin-bottom: 20px;
          font-size: 14px;
          font-weight: 600;
          color: #E91E63;
        }

        .contact-badge i {
          font-size: 18px;
        }

        .contact-title {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 800;
          color: #1a1a1a;
          margin-bottom: 16px;
          letter-spacing: -0.02em;
        }

        .contact-description {
          font-size: clamp(1rem, 2vw, 1.15rem);
          color: #666;
          line-height: 1.7;
          margin-bottom: 32px;
        }

        /* Quick Links Grid */
        .quick-links-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
          margin-bottom: 32px;
        }

        .quick-link-card {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 16px;
          background: white;
          border: 2px solid #f0f0f0;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .quick-link-card:hover {
          border-color: #E91E63;
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(245, 166, 35, 0.2);
        }

        .quick-link-card i {
          font-size: 20px;
          color: #E91E63;
        }

        .quick-link-card span {
          font-size: 14px;
          font-weight: 600;
          color: #333;
        }

        /* Contact Actions */
        .contact-actions {
          display: flex;
          gap: 16px;
          flex-wrap: wrap;
        }

        .contact-btn {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 16px 28px;
          border-radius: 12px;
          border: none;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .primary-contact-btn {
          background: linear-gradient(135deg, #E91E63, #c41849);
          color: white;
        }

        .primary-contact-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 25px rgba(245, 166, 35, 0.4);
        }

        .secondary-contact-btn {
          background: white;
          color: #E91E63;
          border: 2px solid #E91E63;
        }

        .secondary-contact-btn:hover {
          background: #E91E63;
          color: white;
          transform: translateY(-3px);
        }

        .contact-btn i {
          font-size: 20px;
        }

        /* Responsive */
        @media (max-width: 991px) {
          .modern-contact-section {
            padding: 60px 0;
          }

          .map-container {
            height: 400px;
            margin-bottom: 40px;
          }
        }

        @media (max-width: 767px) {
          .map-container {
            height: 350px;
          }

          .quick-links-grid {
            grid-template-columns: 1fr;
          }

          .contact-actions {
            flex-direction: column;
          }

          .contact-btn {
            width: 100%;
            justify-content: center;
          }

          .location-tags {
            flex-direction: column;
            width: 100%;
          }

          .tag {
            text-align: center;
          }
        }
      `}</style>
    </section>
  );
};

export default ContactMap;